import { createFileRoute } from '@tanstack/react-router'
import { CustomerBuyersPage } from '@/features/customer/pages/buyers'

export const Route = createFileRoute('/_authenticated/customer/targets')({
  component: CustomerBuyersPage,
})
